import { OnlineReservationInListDTO } from 'core/api';
import { handleServerErrors } from 'core/infrastructure';
import { Toaster } from 'core/ui-next';
import { OnlineReservationFacade } from 'pos/facades';

export default async function getAvailableReservations(date: Date, idTable: string): Promise<OnlineReservationInListDTO[]> {

	const result = await handleServerErrors(() => OnlineReservationFacade.getBy(date, idTable), {
		onDomainError: async (printError) => {
			Toaster.warn(printError.message);
		}
	});

	return result.ok ? result.value : [];
}

